import { storyblokEditable } from "gatsby-source-storyblok"

import { linkIsExternalUrl } from "../../../../../utils/storyblok"
import ProductCatalogueHero from "../../../../V2/Heroes/Product/CatalogueHero"

import { isConsolidatedPurchasableItem } from "@hooks/V2/storyblok/useConsolidatedItem"
import { useShopItems } from "@hooks/V2/storyblok/useShopItems"
import { withPrefix } from "@utils/url"
import React from "react"

const StoryblokProductCatalogueHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ProductCatalogueHero>) => {
  const { heroItems } = useShopItems(blok.useInternalItems)

  const onlineProducts = (blok.onlineProducts || []).map((item) => ({
    name: item.title,
    thumbnail: item.image,
    link: item.link,
  }))

  const createHeroProduct = (consolidatedItem: YocoCom.ConsolidatedItem) => {
    if (!consolidatedItem.thumbnail?.filename) {
      return undefined
    }

    const ctaLink = consolidatedItem.ctaLink ?? withPrefix("/")
    const detailsLink = consolidatedItem.detailsLink ?? withPrefix("/")
    const preferDetailsLink =
      isConsolidatedPurchasableItem(consolidatedItem) &&
      linkIsExternalUrl(ctaLink)

    return {
      name: consolidatedItem.catalogueTitle,
      thumbnail: consolidatedItem.thumbnail,
      link: preferDetailsLink ? detailsLink : ctaLink,
    }
  }

  const products = heroItems.flatMap(
    (consolidatedItem) => createHeroProduct(consolidatedItem) ?? []
  )

  return (
    <ProductCatalogueHero
      headingText={blok.headingText}
      products={products}
      onlineProducts={onlineProducts}
      backgroundColor={blok.backgroundColor}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokProductCatalogueHero
